import { useEffect } from 'react';

const THOUGHTMETRIC_ID = 'ID-ef14867ae28f8304';
const THOUGHTMETRIC_SCRIPT_SRC = 'https://pixel.thoughtmetric.io/tmpixel.min.js';

// Extend the Window interface to include our custom flag and Thoughtmetric
declare global {
  interface Window {
    __thoughtmetricLoaded?: boolean;
    thoughtmetric?: (...args: any[]) => void;
    thoughtmetricQueue?: any[];
  }
}

function useThoughtmetric() {
  useEffect(() => {
    // Check global flag first
    if (window.__thoughtmetricLoaded) {
      return;
    }

    // Initialize Thoughtmetric using the script provided by the service
    // This creates the thoughtmetric function and queue
    window.thoughtmetricQueue = window.thoughtmetricQueue || [];
    window.thoughtmetric =
      window.thoughtmetric ||
      function () {
        (window.thoughtmetricQueue as any[]).push(arguments);
      };

    // Create the script element
    const script = document.createElement('script');
    script.async = true;
    script.src = THOUGHTMETRIC_SCRIPT_SRC;

    // Set the flag before appending
    window.__thoughtmetricLoaded = true;

    // Insert the script before the first script in the document
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode?.insertBefore(script, firstScript);

    // Initialize Thoughtmetric
    window.thoughtmetric('init', THOUGHTMETRIC_ID);
    window.thoughtmetric('pageview');

    // No cleanup function - similar to other analytics scripts
    // We prefer to let it persist throughout the session
  }, []);
}

export default useThoughtmetric;
